// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .share {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
  margin-bottom: 20px;
  margin-top: 20px;
}
.theme-light .share .container {
  padding: 20px;
}
.theme-light .share .container .top {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-light .share .container .top img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .share .container .top input {
  border: none;
  outline: none;
  padding: 20px 10px;
  background-color: transparent;
  width: 60%;
  color: #000;
}
.theme-light .share .container hr {
  margin: 20px 0px;
  border: none;
  height: 0.5px;
  background-color: lightgray;
}
.theme-light .share .container .bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.theme-light .share .container .bottom .left {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-light .share .container .bottom .left .item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.theme-light .share .container .bottom .left .item img {
  height: 20px;
}
.theme-light .share .container .bottom .left .item span {
  font-size: 12px;
  color: gray;
}
.theme-light .share .container .bottom .right button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
  background-color: #5271ff;
  border-radius: 3px;
}
.theme-dark .share {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
  margin-bottom: 20px;
  margin-top: 20px;
}
.theme-dark .share .container {
  padding: 20px;
}
.theme-dark .share .container .top {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-dark .share .container .top img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .share .container .top input {
  border: none;
  outline: none;
  padding: 20px 10px;
  background-color: transparent;
  width: 60%;
  color: #fffef9;
}
.theme-dark .share .container hr {
  margin: 20px 0px;
  border: none;
  height: 0.5px;
  background-color: #444;
}
.theme-dark .share .container .bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.theme-dark .share .container .bottom .left {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-dark .share .container .bottom .left .item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.theme-dark .share .container .bottom .left .item img {
  height: 20px;
}
.theme-dark .share .container .bottom .left .item span {
  font-size: 12px;
  color: gray;
}
.theme-dark .share .container .bottom .right button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
  background-color: #5271ff;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/share/share.scss"],"names":[],"mappings":"AAqBI;ECfA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADR;AAEQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAAV;AAGQ;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;AADV;AAKM;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AAHR;AAMM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAJR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHV;AAKU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAHZ;AAKY;EACE,YAAA;AAHd;AAMY;EACE,eAAA;EACA,WAAA;AAJd;AASU;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAPZ;AD/CI;ECfA,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAmEJ;AAjEI;EACE,aAAA;AAmEN;AAlEM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAoER;AAnEQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAqEV;AAlEQ;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,cAAA;AAoEV;AAhEM;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAkER;AA/DM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAiER;AAhEQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAkEV;AAhEU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAkEZ;AAhEY;EACE,YAAA;AAkEd;AA/DY;EACE,eAAA;EACA,WAAA;AAiEd;AA5DU;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AA8DZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.share {\n  @include themify($themes) {\n    -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    border-radius: 20px;\n    background-color: themed(\"bg\");\n    color: themed(\"textColor\");\n    margin-bottom: 20px;\n    margin-top: 20px;\n\n    .container {\n      padding: 20px;\n      .top {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        img {\n          width: 40px;\n          height: 40px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n\n        input {\n          border: none;\n          outline: none;\n          padding: 20px 10px;\n          background-color: transparent;\n          width: 60%;\n          color: themed(\"textColor\");\n        }\n      }\n\n      hr {\n        margin: 20px 0px;\n        border: none;\n        height: 0.5px;\n        background-color: themed(\"border\");\n      }\n\n      .bottom {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        .left {\n          display: flex;\n          align-items: center;\n          gap: 20px;\n\n          .item {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            cursor: pointer;\n\n            img {\n              height: 20px;\n            }\n\n            span {\n              font-size: 12px;\n              color: gray;\n            }\n          }\n        }\n        .right {\n          button {\n            border: none;\n            padding: 5px;\n            color: white;\n            cursor: pointer;\n            background-color: #5271ff;\n            border-radius: 3px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
